import React from 'react'

// RELEASE-TENIS10 § 11 P92 (Tudor 2026-10-26; canvas R2 · 6, CP2-event): an event — every event — is played on one surface or more. The
// first one ticked is its main surface, `courtType`, which the exports and the tournament proposals keep reading; the website's header and
// the Tenis10 programme show them all.

/** The event's surfaces: its list, or the one `courtType` of an event saved before. */
export const surfacesOf = values => Array.isArray(values?.courtSurfaces) && values.courtSurfaces.length ? values.courtSurfaces
  : values?.courtType ? [values.courtType] : []
/** The list after ticking or clearing one surface: a new one goes last, so the first stays the main one. */
export const toggleSurface = (list, key, checked) => checked ? (list.includes(key) ? list : [...list, key]) : list.filter(item => item !== key)
/** The fields a choice sets: the list and its first, the main surface. */
export const surfaceFields = list => ({ courtSurfaces: list, courtType: list[0] ?? '' })
export const surfacesError = (values, options) => {
  const list = surfacesOf(values)
  if (!list.length) return 'Select at least one court surface.'
  if (list.some(key => !(options || []).some(option => option.key === key))) return 'Select the court surfaces from the list.'
  return undefined
}
export const surfaceLabel = option => option?.name || option?.value || option?.label || option?.key
export const SURFACES_HELP = 'One or more, for every event. The first one ticked is the main surface — the exports and the tournament proposals keep reading it as today.'

export default function CourtSurfaceChoices({ id, options, value, onChange, error, disabled = false }) {
  return <fieldset className="court-surface-choices" aria-describedby={id + '-help'} aria-invalid={Boolean(error)}>
    <legend className="col-form-label p-0">Court surfaces <span aria-hidden="true">*</span></legend>
    <div className="d-flex flex-wrap">{(options || []).map(option => {
      const checked = value.includes(option.key)
      return <label key={option.key} className={'court-surface-option border rounded px-2 py-1 mr-2 mb-2' + (checked ? ' border-primary text-primary' : '')}>
        <input type="checkbox" className="mr-1" checked={checked} disabled={disabled} onChange={event => onChange(toggleSurface(value, option.key, event.target.checked))} />
        {surfaceLabel(option)}{checked && value[0] === option.key && value.length > 1 ? ' · main' : ''}
      </label>
    })}</div>
    <small id={id + '-help'} className={error ? 'text-danger' : 'text-muted'}>{error || SURFACES_HELP}</small>
  </fieldset>
}
